import {cr} from 'fire-wind-water';
import {renderTEXT} from './text';
import {renderTIME} from './time';
import {renderFILE} from './file';
import {renderLIST} from './list';
import {renderDESC} from './desc';
import {renderPOLICY} from './policy';
import {FieldEvent} from './settings';

export function resetRender(b) {
  cr.each(FieldEvent, d => {
    // 如果不是强制全部渲染，只渲染验证不通过的组件
    if (!b && !d.invalid) {
      return;
    }
    switch (d.fieldType) {
      case 'TEXT':
        renderTEXT(d.fieldName);
        break;
      case 'FILE':
        renderFILE(d.fieldName);
        break;
      case 'DATETIME':
        renderTIME(d.fieldName);
        break;
      case 'LIST':
        d.isShow = false;
        renderLIST(d.fieldName);
        break;
      case 'DESC':
        renderDESC(d.fieldName);
        break;
      case 'POLICY':
        renderPOLICY(d.fieldName);
        break;
    }
  });
}